import axios from 'axios'

// Get business defaults
const get = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business-default`)
  return data
}

// Update business defaults
const update = async (
  hourCloseSale,
  maxTicketUser,
  ticketWidth
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/business-default`, {
    hourCloseSale,
    maxTicketUser,
    ticketWidth
  })
  return data
}

export {
  get,
  update
}
